import withList from '../../with-list/main';
import { selectors, actions } from './';
import table from './table-initial-data';

export default withList(selectors, actions, table, {
	link: '/banners/publications/editor',
	text: 'Create banner publication'
});


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/banners/publication/list/main.js